
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 8.052v4.157","fill":"none","stroke":"#bac1cc","stroke-linecap":"round","stroke-width":"2","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M15.025 2.497a8.319 8.319 0 00-8.328 8.315v2.622a6.474 6.474 0 01-.788 2.847l-1.588 2.646a2.661 2.661 0 001.5 4.058 29.233 29.233 0 0018.42 0 2.77 2.77 0 001.5-4.058l-1.587-2.647a6.521 6.521 0 01-.788-2.847v-2.621a8.37 8.37 0 00-8.341-8.315z","fill":"none","stroke":"#bac1cc","stroke-linecap":"round","stroke-width":"2"}}),_c('path',{attrs:{"data-name":"Vector","d":"M19.158 23.533A4.172 4.172 0 0115 27.69a4.165 4.165 0 01-2.933-1.223 4.165 4.165 0 01-1.224-2.934","fill":"none","stroke":"#bac1cc","stroke-width":"2","opacity":".4"}})])
          )
        }
      }
    